import React from 'react';
import { Link } from 'react-router-dom';
export function ScreenPrintingAdvice() {
  const infoPages = [{
    name: 'FAQs',
    path: '/12.html'
  }, {
    name: 'Compliance',
    path: '/Compliance'
  }, {
    name: 'Screen Printing Advice',
    path: '/Screen-Printing-Advice'
  }, {
    name: 'What is Vector Art?',
    path: '/What-is-Vector-Art'
  }, {
    name: 'The Wear Haus Way',
    path: '/The-Wear-Haus-Way'
  }, {
    name: 'Terms and Conditions',
    path: '/Terms'
  }, {
    name: 'Privacy Policy',
    path: '/Privacy'
  }];
  return <div className="flex flex-col w-full" data-id="element-656">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-yellow to-yellow-500 py-16" data-id="element-657">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-658">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-659">
            Screen Printing Advice
          </h1>
          <p className="text-xl text-gray-800" data-id="element-660">Tips and Best Practices</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50" data-id="element-661">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-662">
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-663">
            {/* Sidebar Navigation */}
            <aside className="lg:w-64 flex-shrink-0" data-id="element-664">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-24" data-id="element-665">
                <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-666">
                  Helpful Info
                </h3>
                <nav className="space-y-2" data-id="element-667">
                  {infoPages.map(page => <Link key={page.path} to={page.path} className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${page.path === '/Screen-Printing-Advice' ? 'bg-wh-pink text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-668">
                      {page.name}
                    </Link>)}
                </nav>
              </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1" data-id="element-669">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-670">
                <div className="prose prose-lg max-w-none text-gray-700" data-id="element-671">
                  <p className="mb-8 text-lg leading-relaxed" data-id="element-672">
                    We want your final product to be amazing! Some limitations
                    are still inherent in the process of garment decoration.
                    Here are a few things to consider when placing a screen
                    print order with us.
                  </p>

                  <div className="mb-10" data-id="element-673">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-674">
                      We don't encourage screen printing over seams or zippers
                    </h2>
                    <p className="mb-6" data-id="element-675">
                      A flat surface is required to get the best quality print
                      when screen printing. T-shirts are consistently smooth and
                      the same thickness, which allows us to create a perfect
                      print. However, when the screen lays over a seam, pocket,
                      or zipper, it creates an inconsistency because these are
                      thicker portions of the garment. When you print over these
                      portions of the garment it creates a gap in the print
                      where the ink from the screen does not touch the shirt due
                      to the ridge caused by the seam.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-676">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-677">
                      We advise against screen printing on ribbed garments
                    </h2>
                    <p className="mb-6" data-id="element-678">
                      Ribbed garments provide a great fit and form for the
                      wearer, but screen printing these garments can be
                      difficult. Screen printed garments lay on a pallet to be
                      printed, and due to the stretchy characteristics of ribbed
                      garments, can be nearly impossible to keep uniform
                      throughout the process. For example, the fabric can move
                      and the ink may not fill the entire image. We advise
                      against printing on ribbed garments because of the
                      unpredictable nature of the final print.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-679">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-680">
                      What colors don't discharge well
                    </h2>
                    <p className="mb-6" data-id="element-681">
                      Not every color garment discharges well. We've done a lot
                      of testing to see what colors discharge well with other
                      colors. If you're looking to do something with discharge
                      screen printing, it's best to contact us first to make
                      sure your chosen colors and garments will work well
                      together.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-682">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-683">
                      Some garments don't de-tag well
                    </h2>
                    <p className="mb-6" data-id="element-684">
                      Many clothing lines will remove the manufacturer's neck
                      tags from the garments so a customized logo can be printed
                      in its place. Most manufacturers understand this, and
                      therefore create their garments with removable (tear-away)
                      tags. There are a handful of these garments that still
                      aren't easy to de-tag, so it's best to contact us with any
                      questions you may have regarding a particular garment
                      choice.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-685">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-686">
                      What shirts don't work well with jumbo prints
                    </h2>
                    <p className="mb-4" data-id="element-687">
                      Jumbo printing is typically not a problem on unisex or
                      men's garments. However, some textiles do have issues:
                    </p>
                    <ul className="list-disc pl-5 mb-6 space-y-2" data-id="element-688">
                      <li data-id="element-689">
                        <span className="font-semibold" data-id="element-690">Tank Tops:</span> Being
                        low cut at both the neckline and the sleeves, printing
                        jumbo prints on these garments can cause print defects
                        because of the seams.
                      </li>
                      <li data-id="element-691">
                        <span className="font-semibold" data-id="element-692">V-Necks:</span> The neck
                        line of the v-neck may cut into the design.
                      </li>
                      <li data-id="element-693">
                        <span className="font-semibold" data-id="element-694">Girls Tees:</span> Jumbo
                        pallets are wider than most girls' tees.
                      </li>
                    </ul>
                    <p className="mb-6" data-id="element-695">
                      As usual, we would love to answer any questions or provide
                      job-specific information. Contact us today for help.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-696">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-697">
                      What garments don't show detail well
                    </h2>
                    <p className="mb-4" data-id="element-698">
                      With advancements in screen printing (including high mesh
                      count screens and specialty presses) we can recreate a
                      level of detail with t-shirts that was previously
                      unattainable just 5-10 years ago. However, due to the way
                      some garments are constructed they will not work well with
                      detail. The reason is that they are not smooth like
                      standard t-shirts. These garments include:
                    </p>
                    <ul className="list-disc pl-5 mb-6 space-y-2" data-id="element-699">
                      <li data-id="element-700">Ribbed Garments</li>
                      <li data-id="element-701">Canvas Material (Aprons, Bags, etc.)</li>
                      <li data-id="element-702">Burnout Tees</li>
                      <li data-id="element-703">Pique Polos</li>
                    </ul>
                  </div>

                  <div className="mb-10" data-id="element-704">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-705">
                      Why isn't every garment perfect?
                    </h2>
                    <p className="mb-6" data-id="element-706">
                      Contrary to popular belief, most t-shirts are not made by
                      giant machines, they're sewn together in facilities by
                      hand. Check out the following video series made by NPR
                      following the creation of a t-shirt:
                    </p>

                    <div className="mb-8 max-w-3xl mx-auto" data-id="element-707">
                      <div className="relative w-full pb-[56.25%] h-0 rounded-lg overflow-hidden shadow-lg bg-gray-100" data-id="element-708">
                        <iframe src="https://www.youtube.com/embed/r2Zod7Sd3rQ" title="Planet Money Makes A T-Shirt" className="absolute top-0 left-0 w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-709"></iframe>
                      </div>
                    </div>

                    <p className="mb-6" data-id="element-710">
                      Due to the human element, not every shirt will be 100%
                      correct. You may have two large shirts that are both the
                      same style but one may have a slightly different cut.
                      Since Wear Haus does not make the shirts, we cannot
                      guarantee that every garment will be made correctly. We do
                      our best to catch these issues before sending the shirts
                      to you, but sometimes these defects can slip through our
                      hands. You may find a hole in your t-shirt or you may see
                      a seam that isn't sewn up the way it should be. If you
                      find any items with holes or rips in them, please let us
                      know and we will work with you on refunding you for the
                      defective items. However, we cannot give refunds for any
                      shirts due to their fit.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-711">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-712">
                      What issues will arise when printing hoodies?
                    </h2>
                    <p className="mb-4" data-id="element-713">
                      Hoodies are one of the more difficult garments to print
                      on, but they are also one of the best selling items during
                      the winter. The following are a few issues to be aware of
                      when printing hoodies:
                    </p>
                    <div className="space-y-4 mb-6" data-id="element-714">
                      <p data-id="element-715">
                        Double lined hoodies can only print 1 color ink and no
                        underbase. They slide around on the press so we cannot
                        accurately register multiple colors.
                      </p>
                      <p data-id="element-716">
                        Pockets on hoodies have to be glued down to print over
                        them. Because of this, when you receive your garments,
                        they may still have some of the glue spray in the
                        pockets. This should wash out after one wash.
                      </p>
                      <p data-id="element-717">
                        Prints on the hood itself vary based on what brand of
                        sweatshirt you are printing on. We may have to heat
                        press the design onto the hood if it is double lined.
                        Only single lined sweatshirts work with hood prints.
                      </p>
                      <p data-id="element-718">
                        We don't advise printing over zippers or seams. When you
                        print over these portions of garments, it creates a gap
                        in the print where the ink in the screen does not hit
                        the shirt due to the ridge caused by the seam.
                      </p>
                      <p data-id="element-719">
                        When you print over the seams, it can throw the
                        registration off. You may see white poking out from
                        under the design.
                      </p>
                      <p data-id="element-720">
                        Hoodies are made with thick fabric and soak up a lot of
                        ink. The color of the sweatshirt will often influence
                        the ink colors. To get the highest quality print when
                        going over zippers &/or pockets, we recommend using a
                        100% cotton or 80/20 blend hoodie and using all
                        discharge colors without an underbase.
                      </p>
                      <p data-id="element-721">
                        When printing hoodies, we cannot mix them with regular
                        t-shirts on an order because they require a different
                        set of equipment and settings on the printing press. If
                        you would like to order the same design on both t-shirts
                        and hoodies, we will need to set up your order as two
                        separate designs.
                      </p>
                    </div>
                  </div>

                  <div className="mb-10" data-id="element-722">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-723">
                      What to do differently on tri-blend tees
                    </h2>
                    <p className="mb-6" data-id="element-724">
                      Flash units on presses burn the tri-blend material, so
                      tri-blend shirts are not underbased. Please take this into
                      account when you order them. Without an underbase,
                      tri-blend tees will have a faded/vintage look, which is
                      what the shirts were intended for. When printing
                      tri-blends we always recommend using either 100% waterbase
                      ink or a waterbase discharge ink to get the softest print
                      possible. If you don't use waterbase ink, your only real
                      option is plasitsol ink. Wear Haus recommends that you
                      only opt for a tri-blend tee if you are looking for a soft
                      shirt with a soft print.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-725">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-726">
                      Why to send extra hem tags or hang tags
                    </h2>
                    <p className="mb-6" data-id="element-727">
                      We do our absolute best to treat every shirt with the
                      utmost care, including any additional items you send us
                      (like hem tags and hang tags). When providing hem tags and
                      hang tags, we strongly recommend that you send at least
                      10% extra when you place your order. During the process of
                      sewing in the tags, they can rip on the machine and if we
                      don't have extras, we cannot ensure that all shirts will
                      be tagged. Wear Haus is not responsible for shirts that
                      are not tagged if extras were not provided. If a tag is
                      misplaced or damaged in the process, Wear Haus will send
                      the shirt untagged but will not refund the cost to sew the
                      tag into the shirt that is missing a tag.
                    </p>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </section>
    </div>;
}